import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


const ZapierChatbot = () => {
    const location = useLocation();
    const hiddenRoutes = ['/login', '/register', '/page-recoverpw', '/logout'];

    useEffect(() => {
        // You can optionally log or trigger events here
    }, []);

    const shouldHide = hiddenRoutes.some(path =>
        location.pathname.startsWith(path)
    );

    if (shouldHide) return null;

    return (
        <div
            dangerouslySetInnerHTML={{
                __html: `<zapier-interfaces-chatbot-embed is-popup='true' chatbot-id='cmcj26isa000k2ufsbim5yg0v'></zapier-interfaces-chatbot-embed>`,
            }}
        />
    );
};

export default ZapierChatbot;